import script from "./AdviserPortal.vue?vue&type=script&setup=true&lang=js"
export * from "./AdviserPortal.vue?vue&type=script&setup=true&lang=js"

import "./AdviserPortal.vue?vue&type=style&index=0&id=68bddfef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68bddfef"]])

export default __exports__